<template>
  <v-container fluid :class="$style['container']">
    <v-overlay :value="processing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <ToolBar>
      <template v-slot:left>
        <Breadcrumb :items="breadcrumbs" />
      </template>
      <template v-slot:middleRight>
        <div class="d-flex align-center">
        </div>
      </template>
      <template v-slot:right>
        <div v-if="!disabledPagination" class="d-flex align-center" style="margin-right: 10px">
          <CSelect
                  style="padding: 0; width: 210px; margin-bottom: 0;"
                  :options="perPageOptions"
                  :value="perPage"
                  @update:value="onChangePerPage"
                  label="1ページあたり:"
                  :horizontal="{ label: 'sm-7', input: 'sm-5'}"
          >
          </CSelect>
        </div>
        <div class="d-flex align-center" style="margin-right: 10px">
          <span style="font-size: 19px;">{{ total }}件</span>
        </div>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-if="!disabledFilterButton" icon v-on="on" @click.stop="onFilter">
              <v-badge :value="filtered" dot top color="red" offset-x="8" offset-y="8">
                <v-icon>mdi-filter-outline</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <span>フィルタ</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon @click="onRefresh" v-on="on">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>再読込</span>
        </v-tooltip>
      </template>
    </ToolBar>
    <div :class="$style['container-content']">
      <v-content class="app-content">
        <v-layout column fill-height>
          <v-flex grow>
            <div :class="$style['main-content']" class="table-responsive">
              <CDataTable
                      :items="entities"
                      :fields="columnsForTable"
                      hover
                      :loading="loading"
                      :clickableRows="true"
                      @row-clicked="moveToShow"
                      style="font-size: 13px !important;"
                      :noItemsView='{ noResults: "データが存在しません", noItems: loading ? "読込中" : "データが存在しません" }'
              >

                <template #publish="{item}">
                  <td>
                <span >
                  {{item.publish === 1 ? "公開" :　
                      ( item.publish === 2 ? "非公開予約:" + item.apply_at : (
                            item.publish === 3 ? "公開予約:" + item.apply_at
                                : "非公開"))}}
                </span>
                  </td>
                </template>
                <template #image="{item}">
                  <td>
                    <div><img style="max-width: 100px;max-height: 100px" :src="item.image" /></div>
                  </td>
                </template>
                <template #checkbox-header="{item, index}">
                  <CInputCheckbox
                          :checked="allSelected"
                          @update:checked="selectAll"
                          @click.stop=""
                          style="margin-top: -13px;"
                          size="lg"
                  >
                  </CInputCheckbox>
                </template>
                <template #checkbox="{item, index}">
                  <td class="py-2">
                    <CInputCheckbox
                            :checked="selected.findIndex(selectItem => selectItem[pk] === item[pk]) >= 0"
                            :value="item[pk]"
                            @update:checked="onCheck(item)"
                            @click.stop=""
                            size="lg"
                    >
                    </CInputCheckbox>
                  </td>
                </template>
                <template #maker_id="{item}">
                  <td>
                      <span >
                        {{resourceName === 'recipes' ? optionName('common/makers', item.maker_id) : item.maker_id}}
                      </span>
                  </td>
                </template>
              </CDataTable>
            </div>
          </v-flex>

          <v-flex :class="$style['container-footer']">
            <div style="position: absolute; bottom: 16px; left: 20px;">
              <v-btn
                      class="mx-1"
                      @click="download"
                      small
                      color="success"
                      max-height="36"
                      depressed
                      :class="$style['control-button']"
              >
                CSVダウンロード
              </v-btn>
              <!-- <v-btn
                      class="mx-1"
                      @click="moveToMaker"
                      small
                      color="success"
                      max-height="36"
                      depressed
                      :class="$style['control-button-wide']"
              >
                インポートはこちらから
              </v-btn> -->
            </div>

            <CPagination
                    v-if="!disabledPagination"
                    :pages="pageLength"
                    :activePage="currentPage"
                    @update:activePage="onChangePage"
                    align="center"
                    style="margin-top: 5px"
            >
            </CPagination>

          </v-flex>

        </v-layout>
      </v-content>
    </div>
    <FilterModal :resourceName="resourceName" :columns="columns" />
  </v-container>
</template>

<script>
  import ToolBar from "@/components/app/toolbar";
  import FilterModal from "@/components/filter-modal";
  import utility from "@/utility";
  import RemoveAction from "@/components/view/actions/remove";
  import DetailAction from "@/components/view/actions/detail";
  import Breadcrumb from "@/components/app/breadcrumb";

  export default {
    components: {
      ToolBar,
      Breadcrumb,
      RemoveAction,
      DetailAction,
      FilterModal
    },
    props: {
      resourceName: {
        type: String,
        required: true
      },
      columns: {
        type: Array,
        required: true
      },
      makerId: {
        type: String,
        required: true
      },
      pk: {
        type: String,
        default: "id"
      },
      disabledAddButton: {
        type: Boolean,
        default: false
      },
      disabledFilterButton: {
        type: Boolean,
        default: true
      },
      disabledPagination: {
        type: Boolean,
        default: true
      },
      disabledCheckbox: {
        type: Boolean,
        default: false
      },
      breadcrumbs: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        allSelected: false
      }
    },
    computed: {
      loading() {
        return this.$store.getters[`${this.resourceName}/csv/isLoading`];
      },
      processing() {
        return this.$store.getters[`${this.resourceName}/csv/isProcessing`];
      },
      entities() {
        return this.$store.getters[`${this.resourceName}/csv/entities`];
      },
      total() {
        return this.$store.getters[`${this.resourceName}/csv/total`];
      },
      currentPage() {
        return this.$store.getters[`${this.resourceName}/csv/page`];
      },
      perPage() {
        return this.$store.getters[`${this.resourceName}/csv/perPage`];
      },
      pageLength() {
        return this.$store.getters[`${this.resourceName}/csv/pageLength`];
      },
      filters() {
        return this.$store.getters["filters/filters"];
      },
      shouldFetch() {
        return this.$store.getters["filters/shouldFetch"];
      },
      filtered() {
        return this.$store.getters["filters/filtered"];
      },
      sort() {
        return this.$store.getters[`${this.resourceName}/csv/sort`];
      },
      columnsForTable() {
        let columnFiltered = this.columns.filter(column => {
          return !(column.isProvider && !this.isProvider);
        });

        let columns = columnFiltered.map(column => {
          if(!(column.isProvider && !this.isProvider)) {
            return {
              key: column.value,
              label: column.text,
              filter: column.filter === undefined ? true : column.filter,
              sorter: column.sorter === undefined ? true : column.sorter,
              _style: 'width:' + column.width + ';',
              // filterable  : column.filterable,
              // divider     : true,
              // class       : column.class,
            };
          }
        });

        return this.disabledCheckbox ? columns : [
          {
            key: 'checkbox',
            label: '',
            _style: 'max-width:30px;',
            sorter: false,
            filter: false
          },
          ...columns
        ];
      },
      optionName() {
        return (optionName, value) => {
          const options =
            this.$store.getters[`${optionName}/options/options`] || [];
          return (options.find(v => v.value === value) || {}).label;
        };
      },
      isProvider() {
        return this.$store.getters[`auth/isProvider`];
      },
      selected() {
        return this.$store.getters[`${this.resourceName}/csv/selected`] || [];
      },
      disableDownloadButton(){
        return this.selected.length < 1;
      }
    },
    watch: {
      shouldFetch(should) {
        if (should) {
          this.fetch(this.currentPage)
            .then(() => {
              this.$store.commit("filters/fetched");
            })
            .catch(() => {
              this.$store.commit("filters/fetched");
            });
        }
      }
    },
    methods: {
      fetch(page) {
        return this.$store.dispatch(`${this.resourceName}/csv/index`, {
          makerId: this.makerId,
          filters: this.filters,
          sort: this.sort
        });
      },
      onRefresh() {
        this.fetch(this.currentPage);
      },
      onFilter() {
        this.$store.commit("filters/open");
      },
      moveToShow(item) {
        this.$router.push({
          path: `/${this.resourceName.replace('download_', '')}/${item[this.pk]}`
        });
      },
      moveToMaker() {
        if (this.isProvider) {
          this.$router.push({
            path: `/makers/${this.makerId}`
          });
        } else {
          if(this.resourceName === 'download_recipes') {
            this.$router.push({
              path: `/recipes`
            });
          } else if(this.resourceName === 'download_products') {
            this.$router.push({
              path: `/products`
            });
          }

        }
      },
      getRowStyle(header) {
        return {
          diplay: "block",
          width: header.width + "px"
        };
      },
      onCheck(row) {
        const index  = this.selected.findIndex(item => item[this.pk] === row[this.pk]);
        if(index >= 0){
          let sliced = this.selected.slice(0, this.selected.length);
          sliced.splice(index, 1);
          this.updateSelected(sliced);
        } else {
          this.updateSelected([
            row,
            ...this.selected
          ])
        }
      },
      selectAll(){
        if(this.allSelected){
          this.updateSelected([]);
          this.allSelected = false;
        }
        else {
          this.updateSelected(this.entities.map(item => {
            return item
          }));
          this.allSelected = true;
        }
      },
      updateSelected(selected) {
        return this.$store.commit(`${this.resourceName}/csv/updateSelected`, {selected});
      },
      showCheckBox(item) {
        return true;
      },
      download() {
        utility
          .$confirm("選択した項目でCSV作成を実行しますか？", "確認", {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
            center: true
          })
          .then(() => {
            this.$store
              .dispatch(`${this.resourceName}/csv/download`, {
                selected: this.selected
              })
              .then(() => {
                this.updateSelected([]);
              });
          })
          .catch(() => {
          });
      }
    },
    created() {
      this.$store.dispatch("filters/initialize");
      this.fetch(1);
    }
  };
</script>

<style module lang="scss">
  $base-app-header-height: 0px;
  $base-index-header-height: 0px;
  $base-index-footer-height: 60px;

  .container {
    width: 100%;
    height: calc(100% - #{$base-app-header-height});
    padding: 0;
    position: relative;
    background-color: #fff;

    .container-content {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      height: calc(100% - #{$base-index-header-height});

      .main-content {
        display: flex;
        position: relative;
        flex-direction: column;
        height: calc(
                100vh - #{$base-index-header-height} - #{$base-index-footer-height}
        );

        :global(.v-data-table.v-data-table--fixed-header) {
          width: 100%;
          position: relative;
          height: calc(
                  100vh - #{$base-index-header-height} - #{$base-index-footer-height}
          );

          :global(.v-data-table__wrapper) {
            height: 100%;
          }
        }

        th > div{
          width: max-content;
        }

        input[type=checkbox] {
          width:			16px;
          height:			16px;
          -moz-transform:		scale(1.15);
          -webkit-transform:	scale(1.15);
          transform:		scale(1.15);
        }
      }
    }

    .container-footer{
      background-color: #fff;
    }

    .pagination {
      height: $base-index-footer-height !important;
    }
  }

  .control-button{
    width: 120px !important;
  }
  .control-button-wide {
    width: 150px !important;
  }

  .toolbar-total {
    position: absolute;
    right: 300px;
  }

  .datepicker{
    div > input{
      border: 1px ridge #333333;
      display: block;
      margin: 5px 5px 10px;
    }
  }
</style>
<style lang="scss">
  select{
    -moz-appearance: auto !important;
    -webkit-appearance: auto !important;
  }

  .form-check-input {
    width: 15px;
    height: 15px;
  }

  .text-bold {
    font-weight: bold !important;
  }
</style>
